if (!customElements.get('quick-add-redirect')) {
  customElements.define(
    'quick-add-redirect',
    class QuickAddRedirect extends HTMLElement {
      constructor() {
        super();
        this.addEventListener('click', this.handleClick.bind(this));
      }

      handleClick(event) {
        event.preventDefault();
        const productUrl = this.getAttribute('data-product-url');
        if (productUrl) {
          window.location.href = productUrl;
        }
      }
    }
  );
}